import { FC, ReactNode } from "react";
import { Text, TextProps } from "@chakra-ui/react";
import { sharedProps } from "~/constants";

interface Props extends TextProps {
  children: ReactNode;
  onClick: () => void;
  to: string;
}

export const ExternalLink: FC<Props> = ({
  children,
  onClick,
  to,
  ...props
}) => {
  return (
    <Text
      as="a"
      color="white"
      href={to}
      onClick={onClick}
      size="md"
      target="_blank"
      {...sharedProps.link.hover}
      {...props}
    >
      {children}
    </Text>
  );
};
